// extracted by mini-css-extract-plugin
export default {"logo":"LoadingLogo_logo__B66Ph","robot":"LoadingLogo_robot__-OQW0","circle":"LoadingLogo_circle__wF7AE","spin":"LoadingLogo_spin__zwyZw"};